if (!customElements.get('upsell-add-button')) {
  customElements.define('upsell-add-button', class UpsellAddButton extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('button');
      this.button.addEventListener('click', this.onClick.bind(this));
    }

    onClick() {
      if (this.button.getAttribute('aria-disabled') === 'true') return;

      const cartDrawer = document.querySelector('cart-drawer');
      this.button.setAttribute('aria-disabled', 'true');
      this.button.classList.add('loading');
      this.querySelector('.loading-overlay').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData();
      formData.append('id', this.dataset.variantId);
      formData.append('quantity', 1);
      if (cartDrawer) {
        formData.append('sections', cartDrawer.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            console.error(response.description);
            return;
          }
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-drawer-upsell' });
          if (cartDrawer) cartDrawer.renderContents(response);
        })
        .catch((e) => console.error(e))
        .finally(() => {
          this.button.classList.remove('loading');
          this.button.removeAttribute('aria-disabled');
          const overlay = this.querySelector('.loading-overlay');
          if (overlay) overlay.classList.add('hidden');
        });
    }
  });
}

if (!customElements.get('cart-drawer-cross-sell')) {
  customElements.define('cart-drawer-cross-sell', class CartDrawerCrossSell extends HTMLElement {
    connectedCallback() {
      this.crossSellSlot = this.querySelector('.cart-drawer__upsell-cross-sell-slot');
      this.heading = this.querySelector('.cart-drawer__upsell-cross-sell-heading');
      this.refresh();
    }

    refresh() {
      const seedId = this.dataset.seedProductId;
      const cartProductIds = (this.dataset.cartProductIds || '').split(',').filter(Boolean);
      const excludeId = this.dataset.excludeProductId;

      if (!seedId) {
        this.renderFallback(cartProductIds, excludeId);
        return;
      }

      fetch(`/recommendations/products.json?product_id=${seedId}&limit=6&intent=related`)
        .then((response) => response.json())
        .then((data) => {
          const candidate = (data.products || []).find((product) => {
            return !cartProductIds.includes(String(product.id)) && String(product.id) !== String(excludeId);
          });

          if (candidate) {
            this.renderCandidate(candidate.url);
            return;
          }

          this.renderFallback(cartProductIds, excludeId);
        })
        .catch(() => this.renderFallback(cartProductIds, excludeId));
    }

    renderFallback(cartProductIds, excludeId) {
      const handle = this.dataset.fallbackHandle;
      const fallbackId = this.dataset.fallbackProductId;

      if (!handle || (fallbackId && (cartProductIds.includes(fallbackId) || fallbackId === excludeId))) {
        this.clear();
        return;
      }

      this.renderCandidate(`/products/${handle}`);
    }

    renderCandidate(url) {
      const separator = url.includes('?') ? '&' : '?';
      fetch(`${url}${separator}section_id=cart-drawer-cross-sell-item`)
        .then((response) => response.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const card = doc.querySelector('[data-cart-upsell-card]');
          if (!card) {
            this.clear();
            return;
          }
          this.crossSellSlot.innerHTML = '';
          this.crossSellSlot.appendChild(card);
          if (this.heading) this.heading.classList.remove('hidden');
        })
        .catch(() => this.clear());
    }

    clear() {
      if (this.crossSellSlot) this.crossSellSlot.innerHTML = '';
      if (this.heading) this.heading.classList.add('hidden');
    }
  });
}

// Open the shipping policy as a popup instead of navigating away from the cart drawer.
document.addEventListener('click', function (event) {
  const link = event.target.closest('.cart-drawer__shipping-note a');
  if (!link) return;

  const modal = document.querySelector('#CartDrawer-ShippingPolicyModal');
  if (!modal) return;

  event.preventDefault();
  modal.show(link);
});
